import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { isDialogOpen, setDialog } from "../../store/slices/global";
import { contactSupport } from "../../utils/contactSupport";
import { carrierServices } from "../../utils/linkSheet";
import openNewTab from "../../utils/openNewTab";

const PREFIX = "CreateShippingErrorDialog";

const classes = {
  root: `${PREFIX}-root`,
  dialogTitle: `${PREFIX}-dialogTitle`,
  dialogText1: `${PREFIX}-dialogText1`,
  dialogText2: `${PREFIX}-dialogText2`,
  articleLink: `${PREFIX}-articleLink`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.dialogTitle}`]: {
    fontSize: "22px",
    fontWeight: 600,
    lineHeight: "unset",
  },
  [`& .${classes.dialogText1}`]: {
    marginTop: "15px",
    marginBottom: "15px",
    color: theme.palette.grey[900],
  },
  [`& .${classes.dialogText2}`]: {
    marginBottom: 15,
  },
  [`& .${classes.articleLink}`]: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    fontWeight: 600,
    "&:hover": {
      color: theme.palette.primary.dark,
      cursor: "pointer",
    },
  },
}));

export const StartShippingErrorDialog = () => {
  const isOpen = useSelector(isDialogOpen("startShippingError"));
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setDialog({ dialog: "startShippingError", open: false }));
  };
  // @ts-ignore
  return (
    <StyledDialog
      open={isOpen}
      onClose={handleClose}
      maxWidth={"sm"}
      fullWidth={true}
      PaperProps={{
        style: {
          borderRadius: 15,
        },
      }}
    >
      <Grid
        container
        direction={"column"}
        alignItems={"center"}
        textAlign={"center"}
      >
        <DialogTitle id="dialogBox-title" className={classes.dialogTitle}>
          <Grid container item direction={"column"}>
            <Grid item>Oops, we can't do that</Grid>
          </Grid>
        </DialogTitle>

        <DialogContent sx={{ width: "400px" }}>
          <Grid container direction={"column"} rowSpacing={2}>
            <Grid item>
              <IgTypography>
                We couldn't start your shipping experiment because you don't
                have Shopify's third-party carrier feature enabled. This feature
                is enabled by default for those on Shopify Advanced and Plus,
                and is available to merchants on the "Shopify" plan for either a
                monthly fee or by switching to yearly billing. You can request
                it by contacting Shopify support. Learn more{" "}
                <IgTypography
                  className={classes.articleLink}
                  onClick={() => {
                    openNewTab(carrierServices);
                  }}
                >
                  here
                </IgTypography>{" "}
                or{" "}
                <IgTypography
                  className={classes.articleLink}
                  onClick={() => {
                    contactSupport();
                  }}
                >
                  contact us
                </IgTypography>{" "}
                with any questions!
              </IgTypography>
            </Grid>
            <Grid item>
              <IgTypography>
                Once you've enabled third-party carriers, click "Resume" on your
                experiment again to launch it.
              </IgTypography>
            </Grid>
          </Grid>
        </DialogContent>
      </Grid>
    </StyledDialog>
  );
};
